import {
  OrderEditingPlatformsConfigSchema,
  OrderEditingTimeConfigSchema,
  OrderEditingToolsConfigSchema,
} from "@redotech/redo-order-editing-onboarding-common/order-editing-config";
import * as z from "zod";

export const completeOrderEditingOnboarding = {
  name: "completeOrderEditingOnboarding" as const,
  input: z.object({
    tools: OrderEditingToolsConfigSchema,
    timeConfig: OrderEditingTimeConfigSchema,
    enabledPlatforms: OrderEditingPlatformsConfigSchema.optional(),
    portalLogo: z.url().max(2048).nullable().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    /**
     * False when the team already has hand-built rules (multiple rules or any
     * filters), which completion refuses to overwrite.
     */
    rulesApplied: z.boolean(),
    error: z.string().optional(),
  }),
};
